"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExponentialBackoff = void 0;
class ExponentialBackoff {
    // arguments are in seconds
    constructor(maxDelay, initialDelay = 2, multiplier = 2) {
        this.initialDelay = initialDelay;
        this.maxDelay = maxDelay;
        this.multiplier = multiplier;
        this.delay = initialDelay;
    }
    call() {
        const delayValue = this.delay;
        this.delay = Math.min(this.delay * this.multiplier, this.maxDelay);
        return delayValue * 1000;
    }
}
exports.ExponentialBackoff = ExponentialBackoff;
